var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1908.917748917749 307.51639800000004",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxHeight: 500
    },
    width: 1908.917748917749,
    height: 307.51639800000004,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#e0ebfc",
    height: 1385.209,
    width: 1920,
    "data-name": "Rectangle 553",
    id: "Rectangle_553"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    transform: "translate(0 487)",
    "data-name": "Group 1702",
    id: "Group_1702"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    transform: "translate(0 -487)",
    "data-name": "Group 1701",
    id: "Group_1701"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0ebfc",
    d: "M0,198.036,5,1385.209H1915l5-1187.173s-390.362-387.911-681.865-77.918S619.06,107.667,492.718,198.036C220.37,392.841,0,198.036,0,198.036",
    "data-name": "Path 1604",
    id: "Path_1604"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentBg);
export default __webpack_public_path__ + "static/media/studentBG.6b68bb4bf5fa068bb499bdde183d037d.svg";
export { ForwardRef as ReactComponent };